module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rankBg"
  }, [_c('div', {
    staticClass: "ulGroup"
  }, [_c('ul', [_c('li', {
    attrs: {
      "url": "singer/list/88"
    },
    on: {
      "click": function($event) {
        return _vm.goSingerList($event)
      }
    }
  }, [_vm._v("热门歌手")])]), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "url": "singer/list/1"
    },
    on: {
      "click": function($event) {
        return _vm.goSingerList($event)
      }
    }
  }, [_vm._v("华语男歌手")]), _vm._v(" "), _c('li', {
    attrs: {
      "url": "singer/list/2"
    },
    on: {
      "click": function($event) {
        return _vm.goSingerList($event)
      }
    }
  }, [_vm._v("华语女歌手")]), _vm._v(" "), _c('li', {
    attrs: {
      "url": "singer/list/3"
    },
    on: {
      "click": function($event) {
        return _vm.goSingerList($event)
      }
    }
  }, [_vm._v("华语组合")])]), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "url": "singer/list/4"
    },
    on: {
      "click": function($event) {
        return _vm.goSingerList($event)
      }
    }
  }, [_vm._v("日韩男歌手")]), _vm._v(" "), _c('li', {
    attrs: {
      "url": "singer/list/5"
    },
    on: {
      "click": function($event) {
        return _vm.goSingerList($event)
      }
    }
  }, [_vm._v("日韩女歌手")]), _vm._v(" "), _c('li', {
    attrs: {
      "url": "singer/list/6"
    },
    on: {
      "click": function($event) {
        return _vm.goSingerList($event)
      }
    }
  }, [_vm._v("日韩组合")])]), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "url": "singer/list/7"
    },
    on: {
      "click": function($event) {
        return _vm.goSingerList($event)
      }
    }
  }, [_vm._v("欧美男歌手")]), _vm._v(" "), _c('li', {
    attrs: {
      "url": "singer/list/8"
    },
    on: {
      "click": function($event) {
        return _vm.goSingerList($event)
      }
    }
  }, [_vm._v("欧美女歌手")]), _vm._v(" "), _c('li', {
    attrs: {
      "url": "singer/list/9"
    },
    on: {
      "click": function($event) {
        return _vm.goSingerList($event)
      }
    }
  }, [_vm._v("欧美组合")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00c804cb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/singer.vue
// module id = 92
// module chunks = 0